module.exports = __webpack_public_path__ + "img/bg_xsfy_gray_m@2x.c949f804.png";